<template>
  <div>
    <TopHeader2 underlineItem="وبلاگ"></TopHeader2>
    <section class="logo-header-resp d-md-none my-5">
      <div class="mx-auto"><img src="@/assets/images/logos/logoBlack.png" alt=""></div>
    </section>

    <main v-if="homeData" class="main">
      <PagesPath :items="['گالری']"></PagesPath>
      <section class="gallery-grid container my-5 py-5">
        <article v-if="homeData.count.video==0" class="gallery-item">
          <div class="gallery-item-img bg-color-ea"><img src="@/assets/images/gallery/photos/pic2.png" alt=""></div>
          <button type="button" class="gallery-svg bg-none"><svg class="icon"><use href="@/assets/svgIcons/svgIcons.svg/#videoPlay"></use></svg></button>
          <div class="files-num d-flex justify-content-between">
            <span class="fontsize-small text-color-222">ویدئوها</span>
            <span class="fontsize-small text-color-222">( <span>{{homeData.count.video}}</span> ) فایل </span>
          </div>
        </article>
        <router-link class="gallery-item" v-else to="/videos?type=main" >
        
          <div class="gallery-item-img bg-color-ea"><img src="@/assets/images/gallery/photos/pic2.png" alt=""></div>
          <button type="button" class="gallery-svg bg-none"><svg class="icon"><use href="@/assets/svgIcons/svgIcons.svg/#videoPlay"></use></svg></button>
          <div class="files-num d-flex justify-content-between">
            <span class="fontsize-small text-color-222">ویدئوها</span>
            <span class="fontsize-small text-color-222">( <span>{{homeData.count.video}}</span> ) فایل </span>
          </div></router-link>
        <article  v-if="homeData.count.image==0" class="gallery-item">
          <div class="gallery-item-img bg-color-ea"><img src="@/assets/images/gallery/photos/pic4.png" alt=""></div>
          <button type="button" class="gallery-svg bg-none"><svg class="icon"><use href="@/assets/svgIcons/svgIcons.svg/#gallery"></use></svg></button>
          <div class="files-num d-flex justify-content-between">
            <span class="fontsize-small text-color-222">تصاویر</span>
            <span class="fontsize-small text-color-222">( <span>{{homeData.count.image}}</span> ) فایل </span>
          </div>
        </article>
        <router-link class="gallery-item" v-else to="/photos?type=main" >
        
          <div class="gallery-item-img bg-color-ea"><img src="@/assets/images/gallery/photos/pic4.png" alt=""></div>
          <button type="button" class="gallery-svg bg-none"><svg class="icon"><use href="@/assets/svgIcons/svgIcons.svg/#gallery"></use></svg></button>
          <div class="files-num d-flex justify-content-between">
            <span class="fontsize-small text-color-222">تصاویر</span>
            <span class="fontsize-small text-color-222">( <span>{{homeData.count.image}}</span> ) فایل </span>
          </div>
  </router-link>
        <article v-if="homeData.count.voice==0"  class="gallery-item">
          <div class="gallery-item-img bg-color-ea"><img src="@/assets/images/gallery/photos/pic3.png" alt=""></div>
          <button type="button" class="gallery-svg bg-none"><svg class="icon"><use href="@/assets/svgIcons/svgIcons.svg/#microphone"></use></svg></button>
          <div class="files-num d-flex justify-content-between">
            <span class="fontsize-small text-color-222">صداها</span>
            <span class="fontsize-small text-color-222">( <span>{{homeData.count.voice}}</span> ) فایل </span>
          </div>
        </article>
        <router-link class="gallery-item" v-else to="/voices" >
        
          <div class="gallery-item-img bg-color-ea"><img src="@/assets/images/gallery/photos/pic3.png" alt=""></div>
          <button type="button" class="gallery-svg bg-none"><svg class="icon"><use href="@/assets/svgIcons/svgIcons.svg/#microphone"></use></svg></button>
          <div class="files-num d-flex justify-content-between">
            <span class="fontsize-small text-color-222">صداها</span>
            <span class="fontsize-small text-color-222">( <span>{{homeData.count.voice}}</span> ) فایل </span>
          </div></router-link>
      </section>
    </main>
    <loader v-else />
  </div>
</template>

<script>
import TopHeader2 from "../components/TopHeader2";
import PagesPath from "../components/PagesPath";

import loader from "@/components/loader.vue";
export default {
  name: "Gallery",
  components:{
    TopHeader2,loader,
    PagesPath

  },
  computed:{
    homeData(){
      return this.$root.homeData;
    }
  },
  mounted() {
    document.querySelectorAll('.gallery-item').forEach(item => {
      item.style.height = item.offsetWidth/2 + 'px' ;
    })


  },
     metaInfo() {
    return {
      title:"گالری ",
      meta: [
        {
          name: "description",
          content:"وبسایت دکتر صادقی فوق تخصص جراحی دندان و اولین ایرانی تولید کننده ارتودنسی های نامرئی"
        },
      ]
    };
  },
}
</script>

<style scoped>
.logo-header-resp>div{
  width: 150px;
}
.logo-header-resp>div img{
  width: 100%;
}
.gallery-grid{
  display: grid;
  grid-template-columns: repeat(3,1fr);
  grid-gap: 2.5rem;
}
.gallery-item{
  border-radius: 15px;
  overflow: hidden;
  height: 150px;
  background-color: white;
  position: relative;
}
.gallery-item svg{
  width: 70px;
  height: 70px;
}
.gallery-item-img{
  width: 100%;
  height: 100%;

}
.gallery-item-img img{
  width: 100%;
  /*height: 100%;*/
  filter:opacity(70%);
}
.gallery-svg{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50% , -50%);
}
.files-num{
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  left: 1rem;
}
@media screen and (max-width: 991px){
  .gallery-grid{
    /*grid-template-columns: repeat(3,1fr);*/
    grid-gap: 1.5rem;
  }
  .gallery-item svg{
    width: 45px;
    height: 45px;
  }
}
@media screen and (max-width: 767px){
  .gallery-grid{
    grid-template-columns: repeat(1,1fr);
    grid-gap: 2.5rem;
  }
  .gallery-item svg{
    width: 80px;
    height: 80px;
  }
}
@media screen and (max-width: 350px){
  .gallery-item svg{
    width: 60px;
    height: 60px;
  }
  .files-num{
    bottom: .5rem;
  }
}
</style>